import { Component, OnInit, OnDestroy, ViewChild, isDevMode } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TransferHttpService } from '../../../../../../src/app/services/transfer-http/transfer-http.service';
import { PermissionsService } from '../../../../../../src/app/services/permissions/permissions.service';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription, Observable } from 'rxjs';
import { EngOverAndAboveProjects } from '../../../../../../src/models';
import { NgForm } from '@angular/forms';
import { EngConfig } from '../engineering-config/engineering-config.component';
import { AIMS_NUMERIC_TYPES } from 'src/app/components/aims-numeric/aims-numeric.component';
import { AimsCommonTableHeader, AimsCommonTablePermissions } from '@aims/common-components';

@Component({
  selector: 'app-oa',
  templateUrl: './oa.component.html',
  styleUrls: ['./oa.component.scss']
})
export class OaComponent implements OnInit, OnDestroy {

  // AimsCommonTable setup
  purchasesTableHeader: AimsCommonTableHeader[] = [
    { key: 'orderDate', label: 'Ord Date', type: 'date' },
    { key: 'edd', label: 'EDD PHQ', type: 'date' },
    { key: 'reqID', label: 'Req ID', type: 'string' },
    { key: 'pO_ID', label: 'PO', type: 'string' },
    { key: 'pO_LN_NO', label: 'Ln', type: 'string' },
    { key: 'orD_QTY', label: 'Qty', type: 'string' },
    { key: 'phqRx', label: 'Phq Rx', type: 'string' },
    { key: 'shipped', label: 'Shipped', type: 'string' },
    { key: 'siteRx', label: 'Site Rx', type: 'string' },
    { key: 'description', label: 'Nomenclature', type: 'string' },
    { key: 'vendor', label: 'Vendor', type: 'string' },
    { key: 'venD_PART_ID', label: 'Vendor P/N', type: 'string' },
    { key: 'unitCost', label: 'Unit Cost', type: 'dynamic' },
    { key: 'totalCost', label: 'Line Total', type: 'dynamic' },
    { key: 'siteCode', label: 'Site', type: 'string' },
    { key: 'reqStatus', label: 'Req Status', type: 'string' },
    { key: 'orderedBy', label: 'Ordered By', type: 'string' },
  ];
  purchasesTablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
    export: true
  };

  laborTableHeader: AimsCommonTableHeader[] = [
    { key: 'tS_DT', label: 'Week Ending', type: 'dynamic' },
    { key: 'fullName', label: 'Employee', type: 'string' },
    { key: 'payType', label: 'Pay Type', type: 'string' },
    { key: 'entereD_HRS', label: 'Hours', type: 'number' },
    { key: 'laB_CST_AMT', label: 'Base Rate', type: 'dynamic' },
    { key: 'fringe', label: 'Fringe', type: 'dynamic' },
    { key: 'nonProd', label: 'NP Rate', type: 'dynamic' },
    { key: 'payrollTax', label: 'PR Tax', type: 'dynamic' },
    { key: 'overhead', label: 'Overhead Rate', type: 'dynamic' },
    { key: 'labor', label: 'Total Cost', type: 'dynamic' },
  ];
  laborTablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
    export: true
  };

  travelTableHeader: AimsCommonTableHeader[] = [
    { key: 'timE_STAMP', label: 'Week Ending', type: 'date' },
    { key: 'name', label: 'Name', type: 'string' },
    { key: 'trN_DESC', label: 'Description', type: 'string' },
    { key: 'amt', label: 'Cost', type: 'dynamic' },
    { key: 'accT_NAME', label: 'Type', type: 'string' },
  ];
  travelTablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
    export: true
  };

  constructor(private route: ActivatedRoute,
    private router: Router,
    private transferHttp: TransferHttpService,
    public permissions: PermissionsService) { }

  destroy$: Subject<boolean> = new Subject();
  oaShow: boolean = false;
  saveClicked: boolean = false;
  isNew: boolean = true;
  spinnerSrc: string = isDevMode() ? '/assets' : 'ClientApp/dist/assets';
  oaProjectName = this.transferHttp.tenantConfig.projectSupport.oaProjectName;

  AIMS_NUMERIC_TYPES = AIMS_NUMERIC_TYPES;

  oa: EngOverAndAboveProjects = new EngOverAndAboveProjects();
  summary: OASummary;

  @ViewChild('oaForm') oaForm: NgForm;

  purchases = [];
  labor = [];
  travel = [];
  workOrders: Observable<any>;

  // getPurchasesForExcel = (grid: GridComponent) => {
  //   const filter = (grid.filter !== undefined) ? grid.filter : <CompositeFilterDescriptor>{ filters: [], logic: 'and' };
  //   let dataToExport = process(this.purchases, { take: 10000, filter: filter, sort: grid.sort }).data;

  //   return <ExcelExportData>{ data: dataToExport };
  // }
  // getLaborForExcel = (grid: GridComponent) => {
  //   const filter = (grid.filter !== undefined) ? grid.filter : <CompositeFilterDescriptor>{ filters: [], logic: 'and' };
  //   let dataToExport = process(this.labor, { take: 10000, filter: filter, sort: grid.sort }).data;

  //   return <ExcelExportData>{ data: dataToExport };
  // }
  // getTravelForExcel = (grid: GridComponent) => {
  //   const filter = (grid.filter !== undefined) ? grid.filter : <CompositeFilterDescriptor>{ filters: [], logic: 'and' };
  //   let dataToExport = process(this.travel, { take: 10000, filter: filter, sort: grid.sort }).data;

  //   return <ExcelExportData>{ data: dataToExport };
  // }

  saveOA() {
    this.saveClicked = true;
    let saving$: Subscription = this.transferHttp.put(`ProjectSupport/SaveOA?isNew=${this.isNew}`, this.oa).subscribe(ret => {
      if (!this.isNew) {
        this.loadOA(this.oa.oanumber);
      }
      else {
        this.router.navigate([`/projectSupport/oa/${this.oa.oanumber}`]);
      }
      saving$.unsubscribe();
    });
  }

  loadOA(oaNum: string) {
    this.isNew = false;
    this.summary = undefined;
    this.transferHttp.getSingle<EngOverAndAboveProjects>(`ProjectSupport/GetOA?oaNumber=${oaNum}`).subscribe(retOa => {
      this.oa = retOa;
      this.oaShow = true;
      if (this.oaForm) {
        this.oaForm.form.markAsPristine();
      }
      //Load Purchases tab
      this.transferHttp.getSingle(`ProjectSupport/GetOAPurchaseDetails?oaNumber=${this.oa.oanumber}`).subscribe(p => this.purchases = p.sort((a, b) => a.orderDate < b.orderDate ? 1 : -1));
      //Load Labor tab
      this.transferHttp.getSingle(`ProjectSupport/GetOALaborDetails?oaNumber=${this.oa.oanumber}`).subscribe(l => this.labor = l.sort((a, b) => a.tS_DT < b.tS_DT ? 1 : -1));
      //Load Travel tab
      this.transferHttp.getSingle(`ProjectSupport/GetOATravelDetails?oaNumber=${this.oa.oanumber}`).subscribe(t => this.travel = t.sort((a, b) => a.timE_STAMP < b.timE_STAMP ? 1 : -1));
      //Load Work Orders tab
      this.transferHttp.getSingle(`ProjectSupport/GetOAWorkOrders?oaNumber=${this.oa.oanumber}`).subscribe(t => this.workOrders = t.sort((a, b) => a.createdOn < b.createdOn ? 1 : -1));
    });

    this.loadSummary(oaNum);
  }

  loadSummary(oaNum: string) {
    //Get summary seperately for speed/DRY
    this.transferHttp.getSingle<Array<OASummary>>(`ProjectSupport/GetOASummaries?oaNumber=${oaNum}`).subscribe(retArr => {
      if (retArr.length > 0) this.summary = retArr[0];
      this.saveClicked = false;
    });
  }

  getTotalTravelCost(): number {
    var totalCost: number = 0;
      this.travel.forEach(t => {
        totalCost += t.amt;
      })
    return totalCost;
  }

  ngOnInit() {
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe(p => {
      if (p['oaNum']) {
        this.loadOA(p['oaNum']);
      }
      else {
        //Load Defaults
        this.transferHttp.getSingle(`ProjectSupport/GetEngConfig?name=${EngConfig.DefaultOverhead}`).subscribe(d => this.oa.overheadPercent = d.configValue);
        this.transferHttp.getSingle(`ProjectSupport/GetEngConfig?name=${EngConfig.DefaultPayrollTax}`).subscribe(d => this.oa.payrollTaxPercent = d.configValue);
        this.transferHttp.getSingle(`ProjectSupport/GetEngConfig?name=${EngConfig.DefaultNonProd}`).subscribe(d => this.oa.nonProductivePercent = d.configValue);
        this.oaShow = true;
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}

class OASummary {
  approvedPrice: number;
  ga: number;
  labor: number;
  oaNumber: string;
  overHead: number;
  projectDescription: string;
  proposalPrice: number;
  purchases: number;
  sites: string;
  travel: number;
}
